/* eslint-disable @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-explicit-any */
import classNames from 'classnames';
import * as React from 'react';

import * as styles from './index.css';

export interface IOfferCardAsideStoreProps {
  height: number;
  isNavigationActive: boolean;
}

export interface IOfferCardAsideDispatchProps {
  setHeight(height: number): void;
}

type IOfferCardAsideProps = IOfferCardAsideStoreProps & IOfferCardAsideDispatchProps;

let isSticky: boolean;
let top: number;

export class OfferCardAside extends React.Component<IOfferCardAsideProps, {}> {
  private container: HTMLDivElement | null;
  private wrapper: HTMLDivElement | null;
  private placeholder: HTMLDivElement | null;

  public componentDidMount() {
    if (!isStickySupported() && isStickyPossible()) {
      this.container!.style.position = 'relative';

      const style = window.getComputedStyle(this.container!);

      top = parseInt(style.top || '0', 10);
      this.wrapper!.style.zIndex = style.zIndex;
      this.wrapper!.style.position = 'relative';
      this.container!.style.top = String(0);
      this.placeholder!.style.overflow = 'hidden';

      this.update();

      window.addEventListener('scroll', this.update);
      window.addEventListener('resize', this.update);
    }

    const rect = (this.container as HTMLDivElement).getBoundingClientRect();

    const { height, setHeight } = this.props;
    if (height !== rect.height) {
      setHeight(rect.height);
    }
  }

  public componentWillUnmount() {
    window.removeEventListener('scroll', this.update);
    window.removeEventListener('resize', this.update);
  }

  public render() {
    const { isNavigationActive, children } = this.props;

    return (
      <div
        ref={ref => (this.container = ref)}
        className={classNames(styles['container'], isNavigationActive && styles['container--active'])}
      >
        <div ref={ref => (this.wrapper = ref)}>{children}</div>
        <div ref={ref => (this.placeholder = ref)} />
      </div>
    );
  }

  private stick = () => {
    if (isSticky) {
      return;
    }

    this.wrapper!.style.position = 'fixed';

    isSticky = true;
  };

  private unstick = () => {
    if (!isSticky) {
      return;
    }

    this.wrapper!.style.position = 'relative';
    this.wrapper!.style.width = '';
    this.wrapper!.style.top = '';
    this.wrapper!.style.left = '';
    this.placeholder!.style.height = '';
    this.placeholder!.style.width = '';

    isSticky = false;
  };

  private update = () => {
    const { isNavigationActive } = this.props;

    const rect = this.container!.getBoundingClientRect();

    if (rect.top < top) {
      this.placeholder!.style.height = `${rect.height}px`;
      this.placeholder!.style.width = rect.width + 'px';

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const parentRect = (this.container!.parentNode as any).getBoundingClientRect();

      this.wrapper!.style.top = `${Math.min(
        parentRect.top + parentRect.height - rect.height,
        top + (isNavigationActive ? 52 : 0),
      )}px`;
      this.wrapper!.style.width = `${rect.width}px`;
      this.wrapper!.style.left = `${rect.left}px`;

      this.stick();
    } else {
      this.unstick();
    }
  };
}

function isStickySupported() {
  const testNode = document.createElement('div');
  if (
    ['', '-webkit-', '-moz-', '-ms-'].some(prefix => {
      try {
        testNode.style.position = prefix + 'sticky';
        // eslint-disable-next-line no-empty
      } catch (e) {}

      return testNode.style.position !== '';
    })
  ) {
    return true;
  }

  return false;
}

function isStickyPossible() {
  if ((window as any).getComputedStyle) {
    return true;
  }

  return false;
}
